//TO-DO set up production URI when hosted

const aelTrackerClientUri = '/api';

export default aelTrackerClientUri;
